
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/numberwale",
      function () {
        return require("private-next-pages/case-study/numberwale.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/numberwale"])
      });
    }
  